import { render, staticRenderFns } from "./GroupRecords.vue?vue&type=template&id=7e511370&scoped=true"
import script from "./GroupRecords.vue?vue&type=script&lang=js"
export * from "./GroupRecords.vue?vue&type=script&lang=js"
import style0 from "./GroupRecords.vue?vue&type=style&index=0&id=7e511370&prod&lang=css"
import style1 from "./GroupRecords.vue?vue&type=style&index=1&id=7e511370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e511370",
  null
  
)

/* custom blocks */
import block0 from "./GroupRecords.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports